import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#253C4A',
            navColor: '#253C4A',
            toolbars: '#e6e6e6',
            background: '#ffffff'
            // primary: '#3E637D' // Medium navy blue
            // primary: '#111F33' // Dark Dark Blue
            // primary: '#5DB88F' // Medical GReen
            // primary: '#0586DD' // royal blue
            // primary: '#2c323f' // medium dark navy
          },
        },
      }
});
